export default __webpack_public_path__ + "static/default-6561860a9c2c3d37cdc0a578591d8b61.png";